// extracted by mini-css-extract-plugin
module.exports = {"sectionSelector":"SectionSelector_sectionSelector__2qxBx","active":"SectionSelector_active__11l3m"};